"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const auth_1 = require("firebase/auth");
/**
 * Obtiene el ```User``` de Firebase.
 *
 * @returns {Promise<User>} {@link https://firebase.google.com/docs/reference/js/v8/firebase.User User}
 */
function getCurrentUser() {
    const auth = (0, auth_1.getAuth)();
    if (!auth) {
        throw new Error("currentUser is null");
    }
    if (!auth.currentUser) {
        throw new Error("currentUser is null");
    }
    return auth.currentUser;
}
exports.default = getCurrentUser;
